import store from '@/store';

export default {
  getAuthToken,
  setAuthToken,
  removeAuthToken,
};

function getAuthToken() {
  return store.state.authToken;
}

function setAuthToken(token, expires) {
  store.commit('setAuthToken', token, expires);
}

function removeAuthToken() {
  store.commit('removeAuthToken');
}
